import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { fetchNotifications } from '../../../features/notification/notificationSlice';

const AdminSidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { unreadCount } = useSelector((state) => state.notification);

  useEffect(() => {
    dispatch(fetchNotifications({ page: 1, limit: 20, role: 'admin' }));
  }, [dispatch]);

  const handleNavigation = (path) => {
    navigate(path);
  };

  const getActiveView = () => {
    if (location.pathname === '/admin' ||
        location.pathname === '/admin/' ||
        location.pathname === '/admin/dashboard') return 'dashboard';
    if (location.pathname.includes('/admin/upcoming-games')) return 'upcomingGames';
    if (location.pathname.includes('/admin/scrape-jobs')) return 'scrapeJobs';
    if (location.pathname.includes('/admin/profile-verifications')) return 'profileVerifications';
    if (location.pathname.includes('/admin/manual-edits')) return 'manualEdits';
    if (location.pathname.includes('/admin/commitment-scanner')) return 'commitmentScanner';
    if (location.pathname.includes('/admin/notifications')) return 'notifications';
    if (location.pathname.includes('/admin/home-page')) return 'homePage';
    return 'dashboard';
  };

  const activeView = getActiveView();

  const getButtonClass = (view) => {
    return `block w-full py-3 px-4 rounded-lg font-medium text-left transition-all ${
      activeView === view
        ? 'bg-jp-accent/10 border border-jp-accent/50 border-l-4 border-l-jp-gold text-jp-accent-ink font-semibold'
        : 'bg-jp-section hover:bg-jp-line text-jp-muted hover:text-jp-ink'
    }`;
  };

  return (
    <div className="p-6 bg-jp-card border border-jp-line rounded-3xl shadow-sm">
      <div className="text-center mb-6">
        {/* Profile Image - Squared with rounded corners */}
        {/* <div className="relative inline-block mb-4">
          <div className="w-40 h-40 rounded-xl bg-jp-section mx-auto overflow-hidden border-2 border-jp-line">
            <img src={profileImage} alt="Profile" className="w-full h-full object-cover" />
          </div>

         
          <div className="absolute bottom-2 left-2 w-10 h-10 bg-purple-500 rounded-full flex items-center justify-center shadow-lg">
            <span className="text-xl font-bold text-jp-ink">A</span>
          </div>
          <div className="absolute bottom-2 right-2 w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-lg">
            <span className="text-2xl">⚙️</span>
          </div>
        </div> */}

        {/* Name and Info */}
        {/* <h3 className="text-jp-ink font-bold text-xl mb-1">Admin User</h3> */}
        <p className="text-jp-accent-ink text-sm font-bold uppercase tracking-widest mb-1">Admin</p>
        {/* <p className="text-jp-muted text-xs mb-4">JUCO PLATFORM</p> */}

        {/* Social Icons */}
        {/* <div className="flex items-center justify-center gap-3 mb-6">
          <a
            href="https://instagram.com"
            target="_blank"
            rel="noopener noreferrer"
            className="w-12 h-12 rounded-full bg-gradient-to-br from-pink-500 to-purple-600 flex items-center justify-center hover:scale-110 transition-transform shadow-lg"
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
            </svg>
          </a>
          <a
            href="https://twitter.com"
            target="_blank"
            rel="noopener noreferrer"
            className="w-12 h-12 rounded-full bg-cyan-500 flex items-center justify-center hover:scale-110 transition-transform shadow-lg"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
              <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
            </svg>
          </a>
        </div> */}
      </div>

      {/* Navigation Links */}
      <div className="space-y-2">
        <button
          onClick={() => handleNavigation('/admin/dashboard')}
          className={getButtonClass('dashboard')}
        >
          Profile
        </button>

        {/* Upcoming Games, Scrape Jobs and Profile Verifications are hidden for now (Profile Verifications
            duplicates Pending Approvals on the dashboard); their pages still work at
            /admin/upcoming-games, /admin/scrape-jobs and /admin/profile-verifications. */}
        {/* <button
          onClick={() => handleNavigation('/admin/upcoming-games')}
          className={getButtonClass('upcomingGames')}
        >
          Upcoming Games
        </button>

        <button
          onClick={() => handleNavigation('/admin/scrape-jobs')}
          className={getButtonClass('scrapeJobs')}
        >
          Scrape Jobs
        </button>

        <button
          onClick={() => handleNavigation('/admin/profile-verifications')}
          className={getButtonClass('profileVerifications')}
        >
          Profile Verifications
        </button> */}

        <button
          onClick={() => handleNavigation('/admin/manual-edits')}
          className={getButtonClass('manualEdits')}
        >
          Manual Edits
        </button>
        <button
          onClick={() => handleNavigation('/admin/commitment-scanner')}
          className={getButtonClass('commitmentScanner')}
        >
          Commitment Scanner
        </button>

        <button
          onClick={() => handleNavigation('/admin/notifications')}
          className={`${getButtonClass('notifications')} relative`}
        >
          Notifications
          {unreadCount > 0 && (
            <span className="absolute right-3 top-1/2 -translate-y-1/2 bg-red-500 text-white text-[10px] font-bold rounded-full min-w-[20px] h-[20px] flex items-center justify-center px-1">
              {unreadCount > 99 ? '99+' : unreadCount}
            </span>
          )}
        </button>

        <button
          onClick={() => handleNavigation('/admin/home-page')}
          className={getButtonClass('homePage')}
        >
          Home Page
        </button>
      </div>
    </div>
  );
};

export default AdminSidebar;
